import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScrewPump2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 123.77,
	height: 40,
	viewBox: "0 0 123.77 40.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 75.0 20.0 L 80.0 20.0 M 15.0 10.0 L 15.0 0.0 M 60.0 30.0 L 60.0 40.0 M 87.0 5.0 A 20.0 20.0 0.0 0 0 87.0 35.0 L 117.0 35.0 A 20.0 20.0 0.0 0 0 117.0 5.0 Z M 87.0 5.0 L 87.0 35.0 M 117.0 5.0 L 117.0 35.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 10,
			width: 75,
			height: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 4.5 20.0 L 10.0 14.0 L 21.0 26.0 L 32.0 14.0 L 43.0 26.0 L 54.0 14.0 L 65.0 26.0 L 70.5 20.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgScrewPump2;
